import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import ProcessButton from '../buttons/ProcessButton';
import { Input, Spin } from "antd";
import { otpIdentityApi, deleteIdentityApi } from '../utils/ApiUtils';

const text2Str = " Enter the code sent to your email and click the red button again.";
const text3Str = "Once your ID data is deleted you will not be ale to buy and watch movies. To get back on the platform you must undergo the verification process again.";

export default function StepSix(props) {
  
    let textColor = props.whiteColor, yellowColor = props.yellowColor, redColor = props.redColor;
    const [loader, setLoader] = useState(false);
    const [otpValue, setOtpValue] = useState("");
    const [message, setMessage] = useState("");
  
    const resendOtp = () => {
        console.log('Resend otp called.');
        setLoader(true);
        otpIdentityApi(props.sessionValue, 'resend')
          .then(response => {
            console.log('Resend otp response='+JSON.stringify(response));
            if(response.info&&response.info.otpstatus=='NOT_VERIFIED') {
              console.log('Resend otp successfully.');
              setLoader(false);
              setMessage('OTP Resent successfully.');
            } else {
              console.log('Resend otp failed!');
              setLoader(false);
              setMessage('Resend otp failed! Please try again.');
            }
        });
    }

    const verifyOtp = () => {
        console.log('Verify otp called.');
        if(otpValue) {
            setLoader(true);
            deleteIdentityApi(props.sessionValue, otpValue)
              .then(response => {
                console.log('Verify otp response='+JSON.stringify(response));
                if(response.info&&response.info.otpstatus=='OK') {
                  console.log('Verify otp successfully.');
                  setLoader(false);
                  props.deleteIDSuccess();
                } else {
                  console.log('Verify otp failed!');
                  setLoader(false);
                  setMessage('Verify otp failed! Please try again.');
                }
            });
        } else {
            setMessage('Please enter the OTP.');
        }
    }

    const onChangeOtp = e => {
        console.log('onChange Otp='+e.target.value);
        setOtpValue(e.target.value);
    }
  
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <FontAwesomeIcon icon={faTrashAlt} style={{ color: redColor, fontSize: 30, marginTop: 30 }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        margin: 30 }}>
            <div style={{ fontSize: 18, fontFamily: 'OpenSans-SemiBold', color: redColor }}>
                DELETE ID DATA
            </div>
            <div style={{ fontSize: 14, fontFamily: 'OpenSans-Regular', color: textColor, lineHeight: 1.2,
            whiteSpace: 'break-spaces', textAlign: 'center', marginTop: 20 }}>
                {text2Str}
            </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingTop: 25, paddingBottom: 25 }}>
            <div style={{ height: 20, fontSize: 12, fontFamily: 'OpenSans-Regular', color: redColor,
                textAlign: 'center', marginBottom: 10 }}>
                {message}
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Input placeholder="CODE" value={otpValue} className='identityInput' onChange={(e)=>{onChangeOtp(e)}} />
            </div>
            <div onClick={() => { resendOtp() }} style={{ cursor: 'pointer', fontSize: 12, fontFamily: 'OpenSans-Regular', color: yellowColor,
            textAlign: 'center', marginTop: 20 }}>
                Resend Code
            </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 20 }}>
            <ProcessButton text="Delete ID Data" bgColor={redColor} onClick={() => verifyOtp()} />
        </div>
        <div style={{ fontSize: 12, fontFamily: 'OpenSans-Regular', color: redColor, lineHeight: 1.2,
            whiteSpace: 'break-spaces', textAlign: 'center', margin: 30, marginTop: 16 }}>
            {text3Str}
        </div>
        { loader &&
            <div style={{ position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center',
            top: 0, left: 0, width: '100%', height: '100%', zIndex: 11, backgroundColor: 'rgba(10, 26, 42, 0.6)' }}>
                <Spin size='large' />
            </div>
        }
      </div>
    );
}